import React from 'react'
import { getWindow } from '@ztechapps/common.utils'

export const useChatWindowLogout = () => {
  const window = getWindow()

  const logout = React.useCallback(() => {
    //call teh logout here
    //this is for beacon specific,
    //window?.Beacon?.('logout', { endActiveChat: true })
    window?.$chatwoot?.reset()
  }, [window?.$chatwoot])

  return logout
}
